import React from 'react'
import { useNavigate } from 'react-router-dom'
import { createPasswordResetTask } from '@/services/firestore/taskService'
import { getSession } from '@/lib/auth'

export default function RequestPasswordReset(){
  const nav = useNavigate()
  const sess = getSession() || {}
  const [email, setEmail] = React.useState(sess.email || '')
  const [reason, setReason] = React.useState('')
  const [busy, setBusy] = React.useState(false)
  const [err, setErr] = React.useState('')
  const [ok, setOk] = React.useState('')

  async function submit(){
    setErr(''); setOk('')
    if (!email) { setErr('Email is required.'); return }
    setBusy(true)
    try {
      await createPasswordResetTask({
        requesterEmail: (sess.email || '').toLowerCase(),
        requesterName: sess.displayName || sess.email || 'User',
        targetEmail: email.toLowerCase(),
        reason: reason.trim() || 'Not specified',
        communityName: sess.communityName || sess.communityCode || '—',
      })
      setOk('Request submitted. An admin will process your reset shortly.')
      setTimeout(()=>nav('/tasks'), 900)
    } catch (e) {
      console.error(e)
      setErr(e?.message || 'Failed to submit request.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="card" style={{maxWidth:600}}>
      <h3>Password Reset Request</h3>
      <p className="muted" style={{marginTop:4}}>
        This creates a task for admins. One admin will claim it, generate a temporary password,
        and share it with you securely.
      </p>

      {err && <div className="alert error" style={{marginTop:8}}>{err}</div>}
      {ok && <div className="alert success" style={{marginTop:8}}>{ok}</div>}

      <div style={{display:'grid', gap:12, marginTop:12}}>
        <div>
          <label>Account email to reset</label>
          <input
            value={email}
            onChange={e=>setEmail(e.target.value)}
            placeholder="user@company.com"
          />
        </div>
        <div>
          <label>Reason (optional)</label>
          <input
            value={reason}
            onChange={e=>setReason(e.target.value)}
            placeholder="Locked out; forgot password; etc."
          />
        </div>
      </div>

      <div style={{marginTop:12, display:'flex', gap:8}}>
        <button onClick={submit} disabled={busy}>{busy ? 'Submitting…' : 'Submit Request'}</button>
        <button className="secondary" onClick={()=>nav('/tasks')}>Cancel</button>
      </div>
    </div>
  )
}